import { AxiosPromise } from 'axios';

export const concurrentRequestsResolver = (requests: AxiosPromise[]) => requests.map((promise: AxiosPromise) => promise.catch((error: Error) => ({ error })));
